export default {"src":"/_next/static/media/0x1e5f6d5355ae5f1c5c687d3041c55f0aeec57eab.64f013ce.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};